export class ticketRequest {
  RunId: any;
  EventId: any;
  RaceId: any;
  Wagers: any[];
  DutchType: any;
  DutchProjections: any;

  constructor(
    RunId: any,
    EventId: any,
    RaceId: any,
    Wagers: any[],
    DutchType: any,
    DutchProjections: any,
  ) {
    this.RunId = RunId;
    this.EventId = EventId;
    this.RaceId = RaceId;
    this.Wagers = Wagers;
    this.DutchType = DutchType;
    this.DutchProjections = DutchProjections;
  }

  calcAmount(): any {
    let amount = 0;
    for (let i = 0; i < this.Wagers.length; i++) {
      amount += this.Wagers[i].calcAmount();
    }
    return amount;
    // return this.numberWithCommas(amount);
  }

  private numberWithCommas(x: number): string {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
}
